/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { DeepLink } from "./DeepLink";
import type { UserResponseDto } from "./UserResponseDto";

export const notificationResponseDtoTypeEnum = {
    "PRODUCT_UPDATE": "PRODUCT_UPDATE",
    "CRUNCH": "CRUNCH",
    "COMPARISON": "COMPARISON",
    "MENTION": "MENTION",
    "TASK": "TASK",
    "DOCUMENT": "DOCUMENT",
    "ERROR": "ERROR",
    "CHANGE_ORDER": "CHANGE_ORDER"
} as const;

export type NotificationResponseDtoTypeEnumKey = (typeof notificationResponseDtoTypeEnum)[keyof typeof notificationResponseDtoTypeEnum];

export type NotificationResponseDto = {
    /**
     * @description Notification ID
     * @type string
    */
    id: string;
    /**
     * @description Type of notification
     * @type string
    */
    type: NotificationResponseDtoTypeEnumKey;
    /**
     * @description Notification title
     * @type string
    */
    title: string;
    /**
     * @description Notification message
     * @type string
    */
    message: string;
    /**
     * @description Whether the notification has been read
     * @type boolean
    */
    read: boolean;
    /**
     * @description Additional data as JSON string
     * @type string | undefined
    */
    notificationContext?: string;
    /**
     * @description Link related to the notification
     * @type array | undefined
    */
    deepLink?: DeepLink[];
    /**
     * @description Notification creation timestamp
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description Notification last update timestamp
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description Notification deletion timestamp (soft delete)
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description User ID this notification belongs to
     * @type string
    */
    userId: string;
    /**
     * @type object | undefined
    */
    user?: UserResponseDto;
};